/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconChangeThemeColor = (props) => (
  <SVG
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.80101 11.003C6.27539 11.9153 5.99909 12.9499 5.99988 14.0028C6.00067 15.0557 6.27852 16.0899 6.80552 17.0014C7.33251 17.9129 8.0901 18.6697 9.00218 19.1958C9.91425 19.7218 10.9487 19.9986 12.0016 19.9983C13.0545 19.998 14.0888 19.7206 15.0006 19.194C15.9123 18.6675 16.6695 17.9102 17.196 16.9984C17.7224 16.0866 17.9997 15.0522 17.9999 13.9993C18.0001 12.9464 17.7232 11.912 17.197 11L12 3L6.80101 11.003Z"
      fill="white"
    />
    <path d="M12 3L12 20L12 3Z" fill="white" />
    <path d="M12 12L15.544 8.456L12 12Z" fill="white" />
    <path d="M12 17.3L17.558 11.742L12 17.3Z" fill="white" />
  </SVG>
)

export default withIconStyles(IconChangeThemeColor)
